import { render, staticRenderFns } from "./loginheader.vue?vue&type=template&id=330e0456&"
import script from "./loginheader.vue?vue&type=script&lang=js&"
export * from "./loginheader.vue?vue&type=script&lang=js&"
import style0 from "./loginheader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports